import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { observer } from "mobx-react";
import PropTypes from "prop-types";

@observer
class InitialAccountSetup extends Component {
  render() {
    const { email, t } = this.props;

    return (
      <div>
        <h2>{t("login:initialAccountSetup")}</h2>
        <p>
          {t("login:weHaveJustSentEmailToEmail", { emailAddress: email })} <strong>{t("login:setYourAccount")}</strong>.
        </p>
        <p>{t("login:pleaseClickLinkFinalizeAccount")}</p>
      </div>
    );
  }
}

InitialAccountSetup.propTypes = {
  email: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(InitialAccountSetup);
